// src/components/PageTransition.jsx
//
// Framer-motion wrapper that plays a brief fade + slight vertical slide
// every time the route changes, giving the portal a native-app feel
// without waiting for expensive animations. Respects
// `prefers-reduced-motion` — users who opted out get the content with
// no animation.

import React from 'react';
import { useLocation } from 'react-router-dom';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';

const PageTransition = ({ children }) => {
  const location = useLocation();
  const prefersReducedMotion = useReducedMotion();

  // Disabled: just pass through so there's no layout jank at all.
  if (prefersReducedMotion) return children;

  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.div
        key={location.pathname}
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -4 }}
        transition={{ duration: 0.2, ease: 'easeOut' }}
        style={{ minHeight: '100%', width: '100%' }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};

export default PageTransition;
